module.exports = __webpack_public_path__ + "static/media/가.9c643b40.jpg";